import HomePage from "@/components/HomePage.vue";
import { createRouter, createWebHistory } from "vue-router";

import UserLogin from "@/user/UserLogin.vue";
import PersonalAgreement from "@/user/PersonalAgreement.vue";
import UserAgreement from "@/user/UserAgreement.vue";
import NotFound from "@/pages/NotFound.vue";
import AdminUsersPage from "@/admin/AdminUsersPage.vue";
import AdminUserGroup from "@/admin/AdminUserGroup.vue";
import AiPrompts from "@/admin/AiPrompts.vue";
import StudentDashboard from "@/admin/StudentDashboard.vue";
import CourseManager from "@/admin/CourseManager.vue";
import ResultsMonitor from "@/admin/ResultsMonitor.vue";
import StudentQA from "@/student/StudentQA.vue"
import QATopics from "@/teacher/QATopics.vue"
import TeacherQADashboard from "@/teacher/TeacherQADashboard.vue"
import ScheduleTable from "@/schedule/ScheduleTable.vue"
export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    return { top: 0 };
  },

  routes: [
    // Публичные страницы
    { name: "home", path: "/", component: HomePage },
    { path: "/login", component: UserLogin },
    { path: "/personal-agreement", component: PersonalAgreement },
    { path: "/user-agreement", component: UserAgreement },

    // Административный интерфейс (Доступ только для админа)
    { name: "users", path: "/users", component: AdminUsersPage, meta: { roles: ["ROLE_ADMIN"] } },
    { name: "groups", path: "/groups", component: AdminUserGroup, meta: { roles: ["ROLE_ADMIN"] } },

    // Преподавательский интерфейс (Админ + Учитель)
    { name: "prompts", path: "/prompts", component: AiPrompts, meta: { roles: ["ROLE_TEACHER", "ROLE_ADMIN"] } },
    { name: "courses", path: "/courses", component: CourseManager, meta: { roles: ["ROLE_TEACHER", "ROLE_ADMIN"] } },
    { name: "results", path: "/results", component: ResultsMonitor, meta: { roles: ["ROLE_TEACHER", "ROLE_ADMIN"] } },

    // Интерфейс студента (Доступен всем авторизованным ролям)
    { name: "student", path: "/student", component: StudentDashboard, meta: { roles: ["ROLE_USER", "ROLE_TEACHER", "ROLE_ADMIN"] } },

    { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
    //qa
    { name: "qa-topics", path: "/qa-topics", component: QATopics, meta: { roles: ["ROLE_TEACHER", "ROLE_ADMIN"] } },
    { name: "qa-teacher", path: "/qa-teacher", component: TeacherQADashboard, meta: { roles: ["ROLE_TEACHER", "ROLE_ADMIN"] } },
    { name: "qa-student", path: "/qa-student", component: StudentQA, meta: { roles: ["ROLE_TEACHER", "ROLE_ADMIN", "ROLE_USER"] } },

//schedule
{ name: "schedule", path: "/schedule", component: ScheduleTable, meta: { roles: ["ROLE_TEACHER", "ROLE_ADMIN", "ROLE_USER"] } },

  ],
});


router.beforeEach((to, from, next) => {
  const publicPages = [
    "/",
    "/personal-agreement",
    "/user-agreement",
    "/login",
  ];

  let authRequired = !publicPages.includes(to.path);
  if (to.path.includes("/login/")) {
    authRequired = false;
  }

  // Достаем строку пользователя из локального хранилища
  const loggedInRaw = localStorage.getItem("essecheck_user");

  // 1. Базовая проверка авторизации
  if (authRequired && !loggedInRaw) {
    return next("/");
  }

  // 2. Ролевая проверка (если пользователь залогинен и страница требует прав)
  if (loggedInRaw && to.meta.roles) {
    try {
      // Парсим JSON пользователя
      const userData = JSON.parse(loggedInRaw);

      // Вытаскиваем роли из payload токена / объекта пользователя
      // Поддерживаем форматы: массив строк userData.roles или строка роли
      let userRoles = [];
      if (userData && userData.roles) {
        userRoles = Array.isArray(userData.roles) ? userData.roles : [userData.roles];
      }

      const requiredRoles = to.meta.roles;

      // Проверяем, есть ли у пользователя хотя бы одна роль, разрешенная для данного роута
      const hasAccess = userRoles.some(role => requiredRoles.includes(role));

      if (!hasAccess) {
        console.warn(`🛑 Роутер: Отказ в доступе к ${to.path} для ролей:`, userRoles);

        // Шлем на домашний роут в зависимости от того, кто пытается прорваться
        if (userRoles.includes("ROLE_USER")) {
          return next("/student"); // Студента шлем сдавать эссе
        } else if (userRoles.includes("ROLE_TEACHER")) {
          return next("/results"); // Учителя шлем в Канбан
        } else {
          return next("/"); // Всех остальных на главную
        }
      }
    } catch (e) {
      console.error("Ошибка парсинга объекта essecheck_user:", e);
      return next("/");
    }
  }

  next();
});


export function pushFilterToURL(options) {
  const filters = Array.isArray(options) ? options : [options];
  const paramsToAdd = filters.reduce((acc, filter) => {
    acc[filter.name] = filter.value;
    return acc;
  }, {});

  const currentRoute = router.currentRoute.value;
  const query = { ...currentRoute.query, ...paramsToAdd };

  router.replace({ query });
}

export function removeFilterFromURL(filterName) {
  const currentRoute = router.currentRoute;
  const query = { ...currentRoute.value.query };

  if (query[filterName]) {
    delete query[filterName];
  }

  router.replace({ query });
}

export function removeFiltersFromURL(filters) {
  const currentRoute = router.currentRoute;
  const query = { ...currentRoute.value.query };
  if(filters){
    filters.forEach(element => {
      console.log("delete:" + element)
      if (query[element]) {
        delete query[element];
      }
    });
  }
  console.log("query:" + query);
  router.replace({ query });
}
